import React from 'react';
import PropTypes from 'prop-types';

import TrialProgramsTableRow from './ProgramsTableRow/TrialProgramsTableRow';

const ProgramsTable = ({ courses, getAccounts }) => {
  return (
    <table className='table-block'>
      <thead className='table-head'>
        <tr className='table-head__row'>
          <td className='table-head__cell'>Назва напряму</td>
          <td className='table-head__cell table-head__cell--center'>Матеріали</td>
          <td className='table-head__cell table-head__cell--center'>Дії</td>
        </tr>
      </thead>
      <tbody className='table-body'>
        {courses.map(course => <TrialProgramsTableRow key={course.id} course={course} getAccounts={getAccounts} />)}
      </tbody>
    </table>
  );
};

ProgramsTable.propTypes = {
  courses: PropTypes.array.isRequired,
  getAccounts: PropTypes.func.isRequired,
};

export default ProgramsTable;